import api from '@/apis'

export default {
  state: {
    visibility: false,
    generating: false,
    result: null
  },
  mutations: {
    INIT_CREATE_AVATAR_DIALOG(state) {
      state.visibility = true
    },
    RESET_CREATE_AVATAR_DIALOG(state) {
      state.visibility = false
      state.generating = false
      state.result = null
    },
    SET_CREATE_AVATAR_DIALOG_GENERATING(state, payload) {
      state.generating = payload
    },
    SET_CREATE_AVATAR_DIALOG_RESULT(state, payload) {
      state.result = payload
    }
  },
  actions: {
    async generateAvatar({ rootState, commit }, payload) {
      try {
        commit('SET_CREATE_AVATAR_DIALOG_RESULT', null)
        commit('SET_CREATE_AVATAR_DIALOG_GENERATING', true)

        const device_id = rootState.auth.selected_device
        const response = await api.generateVideoAvatar({ params: { device_id, properties: { ...payload } } })
        if (response.data.success) {
          commit('SET_CREATE_AVATAR_DIALOG_RESULT', response.data.data)
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_CREATE_AVATAR_DIALOG_GENERATING', false)
      }
    }
  }
}
